import { render } from "./PopupCookie.vue?vue&type=template&id=1370710a"
import script from "./PopupCookie.vue?vue&type=script&lang=js"
export * from "./PopupCookie.vue?vue&type=script&lang=js"

import "./PopupCookie.vue?vue&type=style&index=0&id=1370710a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__